<template>
    <div> 
        <!-- <multiselect class="form-control" v-model="modelo.idciudadext" :options="datos" track-by="id" label="label" 
        :searchable="true" :close-on-select="true" :show-labels="false" placeholder="Seleccione..." :allow-empty="true"></multiselect> -->

        <v-combobox class="form-control" :items="datos" v-model="modelo.idciudadext" item-text="nombre" item-value="id" label="ciudad" autocomplete="new-city" 
        hide-details dense :loading="loading" required="true" ></v-combobox>
    </div>
</template>

<script> 
export default {
    props:{ 
        model:Object,
        default:{type:Object,required:false,default:null},
        showext:{Boolean, default: false},
        panama:{Boolean, default: false}
    },
    data(){
        return{
            datos: [],
            loading: false,
            modelo: {
                idciudadext: null,
            }
        }
    },
    watch:{
        'modelo.idciudadext': function(){this.model.idciudadext=this.modelo.idciudadext; },
        'default':function(a){
            if( a == null ) return;
            this.modelo.idciudadext = a;
            this.setdefault();
        },
    },
    methods:{
        setdefault(){
            if(this.default){
                const select = this.datos.find(x=>x.id==this.default.id);
                this.modelo.idciudadext = select;
            }
        }, 
        async getDatos(iddepa=null) {
            this.datos = [];
            if(iddepa){
                this.cargarDatos2(iddepa);
            }
        }, 
        async cargarDatos2(iddepa){
            let myHeaders = new Headers();
			myHeaders.append("Content-Type", "application/json");
            let sqlp = `query{ busquedaCuidades(iddepartamento:${iddepa},nombre:""){ id nombre iddepartamento } }`;
            let graaa = JSON.stringify({ query: sqlp, variables: {} });
            let reqq = { method: "POST", headers: myHeaders, body: graaa };
            this.loading = true;
            window.console.log('cities:::::', process.env.VUE_APP_API_PUBLIC);
            window.console.log('reqqqq:::::', reqq);
            
            const r = await fetch(process.env.VUE_APP_API_PUBLIC, reqq).then((response) => response.json());
            if(r && r.data){ 
                let cities = r.data.busquedaCuidades;
                window.console.log('cities:::', cities)
                cities.forEach(d => d.label = `${d.nombre}` ); 
                this.datos = cities;
            }
            this.loading = false;
        },
    },
    mounted(){
        this.getDatos();
    }
}
</script>